/** @format */

import { CssBaseline, ThemeProvider } from '@mui/material';
import { RouterProvider } from 'react-router-dom';
import router from './Routes/routes';
import { useMUITheme } from './theme';
import { useAppContext } from './store/store.app';
import useIdleLogout from './hooks/useIdleLogout';
import './Style/index.css';
import './Style/fonts.css';
import 'animate.css';
import 'react-date-range/dist/styles.css'; 
import 'react-date-range/dist/theme/default.css';

function App() {
  const {
    appStore: { activeTheme },
  } = useAppContext();
  const theme = useMUITheme(activeTheme);
  useIdleLogout();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}

export default App;
